import React from 'react';
import { useIntl } from 'react-intl-next';
import { AutoDismissFlag } from '@atlaskit/flag';
import SuccessIcon from '@atlaskit/icon/core/migration/success--check-circle';
import { G300 } from '@atlaskit/theme/colors';
import { messages } from '../messages';
import { IntlProviderWithResolvedMessages } from './IntlProviderWithResolvedMessages';
var FeedbackFlag = function FeedbackFlag(_ref) {
  var description = _ref.description,
    title = _ref.title;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(AutoDismissFlag, {
    icon: /*#__PURE__*/React.createElement(SuccessIcon, {
      spacing: "spacious",
      color: "var(--ds-icon-success, ".concat(G300, ")"),
      label: "Success"
    }),
    id: "feedbackSent",
    description: description || formatMessage(messages.feedbackSuccessFlagDescription),
    title: title || formatMessage(messages.feedbackSuccessFlagTitle)
  });
};
var FeedbackFlagWithIntl = function FeedbackFlagWithIntl(props) {
  return /*#__PURE__*/React.createElement(IntlProviderWithResolvedMessages, {
    locale: props.locale
  }, /*#__PURE__*/React.createElement(FeedbackFlag, props));
};
export default FeedbackFlagWithIntl;